import React from "react";
import { withRouter } from "react-router-dom";
import AppContext from "../../AppContext";
import { Button } from "reactstrap";

import { withTranslation } from "react-i18next";
import i18next from "i18next";

import styles from "../../styles/products.module.css";

class ImprintExt extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      overlayToggle: false,
    };
  }

  static contextType = AppContext;

  componentDidMount() {
    const { i18n } = this.props;
  }

  openAgbInNewTab = (url) => {
    window.open(url, "_blank");
  };

  render() {
    const { t } = this.props;

    if (i18next.exists("imprint.button", { fallbackLng: "false" })) {
      return (
        <>
          <Button
            onClick={(e) => {
              this.openAgbInNewTab(t("imprint.url"));
            }}
            className={`${styles.privacypolicyBtn}`}
          >
            {t("imprint.button")}
            <svg
              className={`${styles.svgIcon}`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 192 192"
            >
              <path
                d="M139.94141 86H140v54H52V52h54v.05859L98.05859 60H60v72h72V93.94141L139.94141 86zM124 36v8h18.34277L93.17139 93.17139l5.65723 5.65723L148 49.65723V68h8V36h-32z"
                stroke="currentColor"
                strokeWidth="4px"
              />
            </svg>
          </Button>
        </>
      );
    } else {
      return false;
    }
  }
}

export default withRouter(withTranslation()(ImprintExt));

